import { MaterialsVolumetricPriceDto } from "#modules/materials/infra/fetchMaterialsVolumetricPrice.api";

export const makeVolumetricMaterialsCsv = (
  materialsVolumetricPrice: MaterialsVolumetricPriceDto,
) => {
  const separator = ";";
  const csvData = [["id", "materialGrade", "name", "price"].join(separator)];
  const rows = materialsVolumetricPrice.map((material) => {
    return [material.id, material.materialGrade, material.name, material.volumetricPrice].join(
      separator,
    );
  });

  return csvData.concat(rows);
};
